import './related.scss';
import 'isotope/dist/isotope.min.css'; // not sure this is working - review

function init() {
}

export default init